import { Component } from '@angular/core';

@Component({
    selector: 'app-people-skeleton',
    standalone: false,
    templateUrl: './people-skeleton.component.html',
    styleUrl: './people-skeleton.component.scss',
})
export class PeopleSkeletonComponent {}
